import React, { useState } from "react";
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import {
  FileDownloadOutlined,
  KeyboardArrowDown,
  PictureAsPdf,
  Slideshow,
} from "@mui/icons-material";
import { exportToPDF, exportToPPT } from "./exportDashboard";

const ExportButton = ({
  getElement,
  fileName = "dashboard",
  title = "",
  subtitle = "",
  disabled = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);
  const open = Boolean(anchorEl);

  const handleExport = async (type) => {
    setAnchorEl(null);
    const el = typeof getElement === "function" ? getElement() : getElement;
    if (!el) return;
    setLoading(true);
    try {
      const opts = { fileName, title, subtitle };
      if (type === "pdf") {
        await exportToPDF(el, opts);
      } else {
        await exportToPPT(el, opts);
      }
    } catch (e) {
      console.error("Export failed:", e);
      // แจ้ง user แทนการล้มเหลวเงียบ ๆ (เช่น รูป avatar โหลดไม่ได้ / เนื้อหายาวเกิน)
      window.alert(
        "สร้างไฟล์ไม่สำเร็จ — อาจมีรูปภาพที่โหลดไม่ได้ หรือเนื้อหายาวเกินไป กรุณาลองใหม่อีกครั้ง"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="outlined"
        disabled={disabled || loading}
        startIcon={loading ? <CircularProgress size={16} /> : <FileDownloadOutlined />}
        endIcon={<KeyboardArrowDown />}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          borderRadius: "8px",
          textTransform: "none",
          color: "#007afe",
          borderColor: "#007afe",
          "&:hover": {
            borderColor: "#1565c0",
            backgroundColor: "rgba(0,122,254,0.04)",
          },
        }}
      >
        Export
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem onClick={() => handleExport("pdf")}>
          <ListItemIcon>
            <PictureAsPdf sx={{ color: "#e53935" }} />
          </ListItemIcon>
          <ListItemText>PDF</ListItemText>
        </MenuItem>
        <MenuItem onClick={() => handleExport("ppt")}>
          <ListItemIcon>
            <Slideshow sx={{ color: "#ff7043" }} />
          </ListItemIcon>
          <ListItemText>PPT</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default ExportButton;
